import { createReducer } from "../../common/reduxUtil";
import {
  COMMENT_ADD,
  COMMENT_LIKE,
  COMMENT_MODAL_HIDE,
  COMMENT_MODAL_SHOW,
  COMMENT_REPLY,
  COMMENT_UNDO_LIKE,
  COMMENT_UPDATE,
  COMMENT_DELETE,
  ENTITY_COMMENT_LIST_SET,
  ENTITY_COMMENT_LIST_UPDATE,
  ENTITY_COMMENT_LIST_REMOVE,
} from "./types";

const initialState = {
  showModal: false,
  showModalMeta: null,
};

export default createReducer(initialState, {
  [COMMENT_ADD]: (state, { comment }) => {
    return Object.assign({}, state, {
      byIds: {
        ...state.byIds,
        [comment._id]: comment,
      },
    });
  },
  [COMMENT_UPDATE]: (state, { commentId, updatedComment }) => {
    return Object.assign({}, state, {
      byIds: {
        ...state.byIds,
        [commentId]: updatedComment,
      },
    });
  },
  [COMMENT_REPLY]: (state, { commentId }) => {
    const currentComment = { ...state.byIds[commentId] };
    return Object.assign({}, state, {
      byIds: {
        ...state.byIds,
        [commentId]: {
          ...currentComment,
          replyCount: currentComment.replyCount + 1,
        },
      },
    });
  },
  [COMMENT_LIKE]: (state, { commentId }) => {
    const currentComment = { ...state.byIds[commentId] };
    return Object.assign({}, state, {
      byIds: {
        ...state.byIds,
        [commentId]: {
          ...currentComment,
          hasUserUpVoted: true,
          votesCount: currentComment.hasUserUpVoted
            ? currentComment.votesCount
            : currentComment.votesCount + 1,
        },
      },
    });
  },
  [COMMENT_UNDO_LIKE]: (state, { commentId }) => {
    const currentComment = { ...state.byIds[commentId] };
    return Object.assign({}, state, {
      byIds: {
        ...state.byIds,
        [commentId]: {
          ...currentComment,
          hasUserUpVoted: false,
          votesCount: !currentComment.hasUserUpVoted
            ? currentComment.votesCount
            : currentComment.votesCount - 1,
        },
      },
    });
  },
  [COMMENT_DELETE]: (state, { commentId }) => {
    const newByIds = { ...state.byIds };
    delete newByIds[commentId];
    return Object.assign({}, state, {
      byIds: newByIds,
    });
  },
  [ENTITY_COMMENT_LIST_SET]: (
    state,
    {
      entityType,
      entityId,
      commentIds,
      options = {
        order: 0,
      },
      totalComments,
    }
  ) => {
    const { order } = options;
    const currentList = [...(state?.[entityType]?.[entityId]?.list || [])];
    let updatedList = [];
    switch (order) {
      case 1:
        updatedList = [...currentList, ...commentIds];
        break;
      case -1:
        updatedList = [...commentIds, ...currentList];
        break;
      case 0:
      default:
        updatedList = [...commentIds];
        break;
    }
    return Object.assign({}, state, {
      [entityType]: {
        ...state[entityType],
        [entityId]: { list: updatedList, totalComments },
      },
    });
  },
  [ENTITY_COMMENT_LIST_UPDATE]: (
    state,
    { entityType, entityId, commentId }
  ) => {
    const comment = state?.[entityType]?.[entityId] || {};
    const list = comment?.list || [];
    return Object.assign({}, state, {
      [entityType]: {
        ...state[entityType],
        [entityId]: {
          list: [...list, commentId],
          totalComments: comment.totalComments + 1,
        },
      },
    });
  },
  [ENTITY_COMMENT_LIST_REMOVE]: (
    state,
    { entityType, entityId, commentId }
  ) => {
    const comment = state?.[entityType]?.[entityId] || {};
    const list = comment?.list || [];
    const updatedList = list.filter((id) => id !== commentId);
    return Object.assign({}, state, {
      [entityType]: {
        ...state[entityType],
        [entityId]: {
          list: updatedList,
          // Don't manually decrement totalComments - let the backend provide accurate count
          totalComments: comment.totalComments,
        },
      },
    });
  },
  [COMMENT_MODAL_SHOW]: (state, { commentId, entity }) => {
    return Object.assign({}, state, {
      showModal: true,
      showModalMeta: {
        ...state.showModalMeta,
        commentId,
        entity,
      },
    });
  },
  [COMMENT_MODAL_HIDE]: (state) => {
    return Object.assign({}, state, {
      showModal: false,
      showModalMeta: null,
    });
  },
});
